import { makeStyles } from "@material-ui/core/styles";

export const useStylesIcon = makeStyles({
    root: {
        height: '44px',
        width: '44px',
        marginLeft: '10px'
    }
});